import { render, staticRenderFns } from "./products-dialog.vue?vue&type=template&id=3491b6bf&"
import script from "./products-dialog.vue?vue&type=script&lang=js&"
export * from "./products-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports